module.exports = __webpack_public_path__ + "static/media/img22.15f9bf34.png";